import api from 'shared/api'

export const loadTags = async ({ name, page }) => {
  if (!name) {
    const { data: list } = await api.get('/public/trending-topics?&limit=20')

    return { list }
  }
  const {
    data: list,
    headers: { 'x-total-results': total },
  } = await api.get(`/tags?page=${page}&limit=20&name=${name}`)

  return { list, total }
}

export const loadPeople = async ({ name, page }) => {
  if (!name) {
    const {
      data: list,
      headers: { 'x-total-results': total },
    } = await api.get(`/public/top-writers?page=${page}&limit=20`)
    return {
      list,
      total,
    }
  }

  const {
    data: list,
    headers: { 'x-total-results': total },
  } = await api.get(
    `/public/profile?page=${page}&limit=20&usernameOrName=${name}`
  )

  return { list, total }
}
